import { useLocation } from 'react-router-dom';
import { failedAttemptParam } from '../../routes';

export const useFailedAttemptQuery = () => {
  const search = new URLSearchParams(useLocation().search);

  return search.get(failedAttemptParam) || undefined;
};
